import DataMapper from './DataMapper'
import VisitPurposeRM from '../responsemodel/VisitPurposeRM'
import VisitPurposeModel from '../../models/VisitPurposeModel'

export default class VisitPurposeDataMapper extends DataMapper<VisitPurposeRM, VisitPurposeModel> {
    map = (rm: VisitPurposeRM) => (new VisitPurposeModel(rm._id, rm.purpose))
}
